// This file can be replaced during build by using the `fileReplacements` array.
// `ng build ---prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  firebase: {
    apiKey: "AIzaSyARqHTbIEi8jcwqiwdgbIPTYU6MF8P-es8",
    authDomain: "blog-5f3ac.firebaseapp.com",
    databaseURL: "https://blog-5f3ac.firebaseio.com",
    projectId: "blog-5f3ac",
    storageBucket: "blog-5f3ac.appspot.com",
    messagingSenderId: "452949738326"
  },
};

/*
 * In development mode, to ignore zone related error stack frames such as
 * `zone.run`, `zoneDelegate.invokeTask` for easier debugging, you can
 * import the following file, but please comment it out in production mode
 * because it will have performance impact when throw error
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
